// extracted by mini-css-extract-plugin
export default {"main":"ItemsNav_main__bKa6e","mainHidden":"ItemsNav_mainHidden__mpHTO","container":"ItemsNav_container__p2kfv","exclusiveBtn":"ItemsNav_exclusiveBtn__PAmY-"};